import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DisplayedGroup, MenuSection } from 'app/models/menu.model';
import { MatDialog } from "@angular/material/dialog";
import {
  MenuSchedulesEntityModalComponent, MenuSchedulesEntityType,
  MenuSchedulesModalData
} from 'app/pages/menu/shared/menu-schedules-entity-modal/menu-schedules-entity-modal.component';

@Component({
  selector: 'app-menu-section-group[group][menuSection]',
  templateUrl: './section-group.component.html',
  styleUrls: ['./section-group.component.scss']
})
export class SectionGroupComponent implements OnChanges {
  @Input() group: DisplayedGroup;
  @Input() menuSection: MenuSection;

  @Output() editMenuGroup = new EventEmitter<any>();

  defaultPicture = 'assets/images/dishes/logo.png';

  groupName = '';
  groupDescription = '';
  productIds = [];
  productsInGroup = [];

  constructor(public dialog: MatDialog) {
  }

  ngOnChanges() {
    this.loadGroupWithOverrides();
  }

  loadGroupWithOverrides(): void {
    this.groupName = this.group.name;
    this.groupDescription = this.group.description;
    this.productsInGroup = this.group.groupStructure.productsInGroup;
    this.productIds = this.group.groupStructure.productsInGroup.map(productInGroup => productInGroup.externalProductId);
  }

  onOpenEditGroupDialog() {
    this.editMenuGroup.emit(this.group);
  }

  onOpenSchedulesGroupDialog() {
    this.dialog.open<MenuSchedulesEntityModalComponent, MenuSchedulesModalData>(
      MenuSchedulesEntityModalComponent,
      {
        data: {
          menuSectionId: this.menuSection.id,
          entityId: this.group.externalId,
          entityType: MenuSchedulesEntityType.GROUP,
        }
      });
  }
}
